import { gql, useQuery } from "@apollo/client";
import { 
  User, 
  QueryRecentBeneficiariesArgs 
} from "../../../schemaTypes";

export const recentBeneficiariesQuery = gql`
  query RecentBeneficiariesQuery($offset: Int!, $limit: Int!) {
    recentBeneficiaries(offset: $offset, limit: $limit) {
      id
      customer{
        id
        avatarUrl
        firstname
        lastname
        email
        username
        phone
        community{
          id
          name
          alias
        }
        createdAt
        updatedAt
        address
        gender
        dob
        nin
      }
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy{
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          # createdAt
          # updatedAt
        }
        # createdAt
        # updatedAt
      }
      # kycStatus
      suspended
      isLocked
      isVerified
      # forgotPasswordLocked
      onboarding{
        id
        status
        currentStep
      }
      role
      # lastLoggedIn
      # createdAt
      # updatedAt
    }
  }
`;

export interface RecentBeneficiariesQuery {
  recentBeneficiaries: User[];
}

export interface WithRecentBeneficiaries {
  users: User[];
  loading: boolean;
}

interface Props {
  variables: QueryRecentBeneficiariesArgs;
  children: (data: WithRecentBeneficiaries) => React.ReactElement | null;
}

export const RecentBeneficiaries: React.FC<Props> = ({ children, variables }) => {
  const { data, loading } = useQuery<RecentBeneficiariesQuery, QueryRecentBeneficiariesArgs>(
    recentBeneficiariesQuery,
    {
      variables,
      notifyOnNetworkStatusChange: true,
    }
  );

  let users: User[] = [];
  if (data && data.recentBeneficiaries) {
    users = data.recentBeneficiaries as User[];
  }

  return children({
    users,
    loading,
  });
};